import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { isValidPhone } from '@/utils/validation';
import { useUpdateCarryProfile } from '../hooks/useCarry';

interface PhoneEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentPhone: string | null;
}

export function PhoneEditDialog({
  open,
  onOpenChange,
  currentPhone,
}: PhoneEditDialogProps) {
  const [phone, setPhone] = useState(currentPhone ?? '');
  const updateProfile = useUpdateCarryProfile();
  const trimmedPhone = phone.trim();
  const isPhoneInvalid = trimmedPhone !== '' && !isValidPhone(trimmedPhone);

  const handleSave = () => {
    updateProfile.mutate(
      { phone: trimmedPhone || null },
      { onSuccess: () => onOpenChange(false) }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit phone number</DialogTitle>
        </DialogHeader>

        <div className="space-y-2">
          <Label htmlFor="carry-phone">Phone</Label>
          <Input
            id="carry-phone"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            disabled={updateProfile.isPending}
            className={isPhoneInvalid ? 'border-red-500' : ''}
          />
          {isPhoneInvalid && (
            <p className="text-sm text-red-600">
              Please enter a valid phone number
            </p>
          )}
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={updateProfile.isPending}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={updateProfile.isPending || isPhoneInvalid}
          >
            {updateProfile.isPending ? 'Saving...' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
